"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AddonSubItem;
var _ListItemButton = _interopRequireDefault(require("@mui/material/ListItemButton"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function AddonSubItem(_ref) {
  let {
    addonSubItem
  } = _ref;
  const labelId = "checkbox-list-label-".concat(addonSubItem.name);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItem.default, {
    disablePadding: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItemButton.default, {
      role: undefined,
      onClick: addonSubItem.selectedListener ? addonSubItem.selectedListener : () => {},
      dense: true,
      sx: {
        margin: 0,
        padding: 0,
        paddingLeft: "1rem"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
          sx: {
            marginLeft: "1rem"
          },
          edge: "start",
          checked: addonSubItem.selected,
          tabIndex: -1,
          disableRipple: true,
          inputProps: {
            "aria-labelledby": addonSubItem.name
          }
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
        primaryTypographyProps: {
          fontSize: '12px',
          fontFamily: 'Lato Regular'
        },
        id: labelId,
        primary: addonSubItem.name
      })]
    })
  });
}